var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeachBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 12C15.25 9.30956 14.8124 6.90837 14.1321 5.20747C13.7911 4.35494 13.4038 3.71536 13.0121 3.30118C12.6219 2.88858 12.2796 2.75 12 2.75C11.7204 2.75 11.3781 2.88858 10.9879 3.30118C10.5962 3.71536 10.2089 4.35494 9.86793 5.20747C9.18757 6.90837 8.75 9.30956 8.75 12C8.75 14.6905 9.18757 17.0916 9.86793 18.7925C10.2089 19.6451 10.5962 20.2847 10.9879 20.6988C11.3781 21.1114 11.7204 21.25 12 21.25C12.2796 21.25 12.6219 21.1114 13.0121 20.6988C13.4038 20.2847 13.7911 19.6451 14.1321 18.7925C14.8124 17.0916 15.25 14.6905 15.25 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0424 21.7913C18.5858 20.8485 22.0001 16.823 22.0001 12C22.0001 7.17706 18.5858 3.15156 14.0424 2.20874C14.0625 2.22912 14.0823 2.24972 14.102 2.27054C14.6674 2.86841 15.142 3.69329 15.5249 4.65041C16.2922 6.5688 16.7501 9.1676 16.7501 12C16.7501 14.8324 16.2922 17.4312 15.5249 19.3496C15.142 20.3067 14.6674 21.1316 14.102 21.7295C14.0823 21.7503 14.0625 21.7709 14.0424 21.7913Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 16.823 5.4143 20.8485 9.95768 21.7913C9.93765 21.7709 9.91779 21.7503 9.8981 21.7295C9.33269 21.1316 8.85806 20.3067 8.47521 19.3496C7.70786 17.4312 7.25 14.8324 7.25 12C7.25 9.1676 7.70786 6.5688 8.47521 4.65041C8.85806 3.69329 9.33269 2.86841 9.8981 2.27054C9.91779 2.24972 9.93765 2.22912 9.95768 2.20874C5.4143 3.15156 2 7.17706 2 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachBall);
export default __webpack_public_path__ + "static/media/beach-ball.7bc4d1ebb718c86bbe66b10874ee4a63.svg";
export { ForwardRef as ReactComponent };